import Nav from '../components/Nav';
import Footer from '../components/Footer';

const sections = [
  {
    title: 'Information We Collect',
    body: [
      'When you submit the free AI audit request form on this website, we collect the information you provide: your name, company name, email address, website URL, and a description of your business challenges.',
      'We may also collect standard technical information automatically when you visit this site, including your IP address, browser type, referring URL, and pages visited. This information is collected through standard web server logs and analytics tools.',
    ],
  },
  {
    title: 'How We Use Your Information',
    body: [
      'We use the information you submit through our contact form solely to respond to your inquiry and to conduct the free AI audit you requested. We will not use your information for unrelated marketing purposes without your consent.',
      'Technical information collected automatically is used only to understand how visitors use this site and to improve its performance and content.',
    ],
  },
  {
    title: 'How We Share Your Information',
    body: [
      'We do not sell, rent, or trade your personal information to third parties.',
      'We may share your information with trusted service providers who assist us in operating this website or conducting our business (for example, email or scheduling tools), provided those parties agree to keep your information confidential.',
      'We may disclose your information if required to do so by law or in response to a valid legal request.',
    ],
  },
  {
    title: 'Data Retention',
    body: [
      'We retain the personal information you submit only as long as necessary to fulfill the purpose for which it was collected or as required by applicable law. If you would like us to delete your information, please contact us at josh@jambition.io and we will honor that request promptly.',
    ],
  },
  {
    title: 'Cookies',
    body: [
      'This website may use cookies or similar tracking technologies to improve your browsing experience and to collect aggregate usage data. You can instruct your browser to refuse cookies, though some parts of the site may not function properly as a result.',
    ],
  },
  {
    title: 'Third-Party Links',
    body: [
      'This website may contain links to third-party websites. We are not responsible for the privacy practices or content of those sites. We encourage you to review the privacy policies of any third-party sites you visit.',
    ],
  },
  {
    title: 'Security',
    body: [
      'We take reasonable technical and organizational measures to protect the personal information we collect from unauthorized access, disclosure, or misuse. However, no method of transmission over the internet is completely secure, and we cannot guarantee absolute security.',
    ],
  },
  {
    title: 'Children\'s Privacy',
    body: [
      'This website is not directed at children under the age of 13. We do not knowingly collect personal information from children. If you believe we have inadvertently collected such information, please contact us and we will delete it immediately.',
    ],
  },
  {
    title: 'Changes to This Policy',
    body: [
      'We may update this Privacy Policy from time to time. When we do, we will revise the "Last updated" date at the top of this page. We encourage you to review this policy periodically to stay informed about how we protect your information.',
    ],
  },
  {
    title: 'Contact Us',
    body: [
      'If you have any questions about this Privacy Policy or how we handle your personal information, please contact us at:',
    ],
    contact: true,
  },
];

export default function Privacy() {
  return (
    <div className="min-h-screen bg-cream font-sans">
      <Nav />

      {/* Header */}
      <section className="pt-28 lg:pt-36 pb-12 border-b border-warm-border">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <p className="text-amber-600 text-xs font-semibold tracking-[0.2em] uppercase mb-5">
            Legal
          </p>
          <h1 className="font-display text-5xl font-bold text-charcoal leading-tight mb-4">
            Privacy Policy
          </h1>
          <p className="text-warm-gray text-sm">
            Last updated: March 31, 2026
          </p>
        </div>
      </section>

      {/* Intro */}
      <section className="py-12 bg-white border-b border-warm-border">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <p className="text-warm-gray text-lg leading-relaxed">
            Jambition ("we," "us," or "our") operates the website jambition.io.
            This Privacy Policy explains how we collect, use, and protect
            information when you visit our website or submit a request through
            our contact form. By using this site, you agree to the practices
            described below.
          </p>
        </div>
      </section>

      {/* Sections */}
      <section className="py-16 bg-cream">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 space-y-12">
          {sections.map((section) => (
            <div key={section.title} className="border-t border-warm-border pt-10">
              <h2 className="font-display text-2xl font-bold text-charcoal mb-5">
                {section.title}
              </h2>
              <div className="space-y-4">
                {section.body.map((para, i) => (
                  <p key={i} className="text-warm-gray leading-relaxed">
                    {para}
                  </p>
                ))}
                {section.contact && (
                  <div className="mt-4 pl-4 border-l-2 border-warm-border space-y-1">
                    <p className="font-semibold text-charcoal">Jambition</p>
                    <a
                      href="mailto:josh@jambition.io"
                      className="text-amber-600 hover:text-amber-700 transition-colors text-sm"
                    >
                      josh@jambition.io
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}
